import React from 'react'
import { NavLink } from 'react-router-dom'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

const projects = [
  {
    image: require('./../../images/projects/square/pic1.jpg'),
    title: 'Oven',
    description: '',
    //   "We provide a range of architectural 3D modeling services to our customers to aid the design",
  },
  {
    image: require('./../../images/projects/square/pic2.jpg'),
    title: 'Electric Kitchen Appliances',
    description: '',
    //   "Analysis and planning services that help both the client and architects to work out the forthcoming project...",
  },
  {
    image: require('./../../images/projects/square/pic3.jpg'),
    title: 'Electric Kitchen Appliances',
    description: '',
    //   "We offer comprehensive Architectural Engineering Services including Interior design, Master planning.",
  },
  {
    image: require('./../../images/projects/square/pic4.jpg'),
    title: 'Heater',
    description: '',
  },

  {
    image: require('./../../images/projects/square/pic5.jpg'),
    title: 'Heater',
    description:
      '',
  },
  {
    image: require('./../../images/projects/square/pic6.jpg'),
    title: '',
    description:
      '',
  },
]

const products = [
  {
    count: '01',
    title: 'Classic Dinner Set',
    flaticon: '',
    image: require('./../../images/services/service-projects/1.jpg'),
  },
  {
    count: '02',
    title: 'Golden Dinner Set',
    flaticon: '',
    image: require('./../../images/services/service-projects/2.jpg'),
  },
  {
    count: '03',
    title: 'Golden Spoons',
    flaticon: '',
    image: require('./../../images/services/service-projects/3.jpg'),
  },
  {
    count: '04',
    title: 'Stainless Spoons',
    flaticon: '',
    image: require('./../../images/services/service-projects/4.jpg'),
  },
  {
    count: '05',
    title: 'Glasses',
    flaticon: '',
    image: require('./../../images/services/service-projects/5.jpg'),
  },
  {
    count: '06',
    title: 'MacroWave',
    flaticon: '',
    image: require('./../../images/services/service-projects/7.jpg'),
  },
]

var bgimg1 = require('./../../images/background/cross-line2.png')

class Projects3 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: false,
      center: false,
      items: 3,
      margin: 40,
      nav: true,
      dots: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
          margin: 15,
        },
        640: {
          items: 2,
          margin: 15,
        },
        768: {
          items: 2,
          margin: 15,
        },
        991: {
          items: 3,
          margin: 15,
        },
        1200: {
          items: 3,
        },
      },
    }
    return (
      <>
        <div
          className={`${this.props.bgcolor} section-full p-tb80  inner-page-padding`}
        >
          <div className="container-fluid">
            <div className="section-content">
              {/* TITLE START */}
              <div className="section-head">
                <div className={`${this.props.alignment} sx-separator-outer`}>
                  {/* <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                  >
                    <h3 className="sep-line-one">test</h3>
                  </div> */}
                </div>
              </div>
              {/* TITLE END */}

              <div className="work-carousel-outer">
                <OwlCarousel
                  className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80"
                  {...options}
                >
                  {products.map((item, index) => (
                    <div key={index} className="item">
                      <div className="project-mas hover-shadow m-a30">
                        <div className="image-effect-one">
                          <img src={item.image} alt="" />
                          <div className="figcaption">
                            <a className="mfp-link" href={item.image}>
                              <i className="fa fa-arrows-alt" />
                            </a>
                          </div>
                        </div>
                        <div className="project-info p-a20 bg-gray">
                          <h4 className="sx-tilte m-t0">
                            {item.title}
                            {/* <NavLink to={"/project-detail1"}>
                              {item.title}
                            </NavLink> */}
                          </h4>
                          <p>{item.description}</p>
                          <NavLink to={'/services-detail'}>
                            <i className="link-plus bg-primary" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>

              <div className="work-carousel-outer">
                <OwlCarousel
                  className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80"
                  {...options}
                >
                  {projects.map((item, index) => (
                    <div key={index} className="item">
                      <div className="project-mas hover-shadow m-a30">
                        <div className="image-effect-one">
                          <img src={item.image} alt="" />
                          <div className="figcaption">
                            <a className="mfp-link" href={item.image}>
                              <i className="fa fa-arrows-alt" />
                            </a>
                          </div>
                        </div>
                        <div className="project-info p-a20 bg-gray">
                          <h4 className="sx-tilte m-t0">
                            {item.title}
                            {/* <NavLink to={"/project-detail1"}>
                              {item.title}
                            </NavLink> */}
                          </h4>
                          <p>{item.description}</p>
                          <NavLink to={'/services-detail'}>
                            <i className="link-plus bg-primary" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Projects3
